var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1278_7760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49987 13.4746L4.6082 10.5829C4.2832 10.2579 3.7582 10.2579 3.4332 10.5829C3.1082 10.9079 3.1082 11.4329 3.4332 11.7579L6.91654 15.2413C7.24154 15.5663 7.76654 15.5663 8.09154 15.2413L16.9082 6.42461C17.2332 6.09961 17.2332 5.57461 16.9082 5.24961C16.5832 4.92461 16.0582 4.92461 15.7332 5.24961L7.49987 13.4746Z",
    fill: "#03CE91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1278_7760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.32d063221956fde030eafc2f6b12e06b.svg";
export { ForwardRef as ReactComponent };